var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Divider, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppointmentServiceAdvisorList, jobCardGetDetailAPI, ModifyAdvisorJobCardUrl, ModifyAdvisorUrl, modifyEstimateUrl, USER_PROFILE_DATA } from '../../api/url';
import { EListCardView, EMenuFeature } from '../../constants';
import { showLoader, showNotification } from '../../redux/commonSlice';
import { getByIdAPI, setState, updateAPI } from '../../redux/crudSlice';
import { getLocalStorageItem } from '../../utils/storageHelper';
import { InputBox } from '../atoms/input';
import { MuiSelectComponent } from '../atoms/muiSelectComponent';
import { MuiStack } from '../atoms/stackComponent';
import Loader from '../molecules/loader';
import { MuiPopup } from '../molecules/popupComponent';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { useParams } from 'react-router-dom';
function AppointmentAssignReassignPopup(props) {
    var _this = this;
    var isOpen = props.isOpen, onClosed = props.onClosed, data = props.data, appointmentData = props.appointmentData, moduleName = props.moduleName;
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    // let name = `${appointmentData?.ServiceAdvisorGivenName} ${appointmentData?.ServiceAdvisorFamilyName}`
    var _a = useState(), selectedAdvisor = _a[0], setSelectedAdvisor = _a[1];
    var _b = useState(''), fromAdvisor = _b[0], setFromAdvisor = _b[1];
    var _c = useState([]), serviceAdvisorList = _c[0], setServiceAdvisorList = _c[1];
    // const lgMode = useMediaQuery('(min-width:600px)');
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var trackButtonClick = useAnalyticsEventTracker('AppointmentAssignReassignPopup');
    var dispatch = useDispatch();
    var id = useParams().id;
    useEffect(function () {
        if (appointmentData !== null && appointmentData !== void 0 && appointmentData.OrganizationId) {
            GetServiceAdvisor(appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.OrganizationId);
        }
    }, []);
    var GetServiceAdvisor = function (branchId) { return __awaiter(_this, void 0, void 0, function () {
        var _advisorList$payload, _advisorList$payload2, request, advisorList, _advisorList$payload3, advisor, FinalAdvisorList, filteredList, filteredAdvisorList, saName, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        BranchId: branchId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "advisorList",
                            url: AppointmentServiceAdvisorList,
                            request: request
                        }))];
                case 2:
                    advisorList = _a.sent();
                    if (!((advisorList === null || advisorList === void 0 || (_advisorList$payload = advisorList.payload) === null || _advisorList$payload === void 0 || (_advisorList$payload = _advisorList$payload.value) === null || _advisorList$payload === void 0 ? void 0 : _advisorList$payload.statusCode) == 200 || advisorList !== null && advisorList !== void 0 && (_advisorList$payload2 = advisorList.payload) !== null && _advisorList$payload2 !== void 0 && (_advisorList$payload2 = _advisorList$payload2.value) !== null && _advisorList$payload2 !== void 0 && _advisorList$payload2.success)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    advisor = advisorList === null || advisorList === void 0 || (_advisorList$payload3 = advisorList.payload) === null || _advisorList$payload3 === void 0 || (_advisorList$payload3 = _advisorList$payload3.value) === null || _advisorList$payload3 === void 0 ? void 0 : _advisorList$payload3.data;
                    FinalAdvisorList = advisor === null || advisor === void 0 ? void 0 : advisor.map(function (item) { return _objectSpread(_objectSpread({}, item), {}, {
                        advisorName: item.GivenName && item.FamilyName ? "".concat(item === null || item === void 0 ? void 0 : item.GivenName, " ").concat(item === null || item === void 0 ? void 0 : item.FamilyName) : null
                    }); });
                    if (appointmentData !== null && appointmentData !== void 0 && appointmentData.AssignedEmployeeId) {
                        filteredList = FinalAdvisorList.filter(function (item, index) { return item.UserId != (appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.AssignedEmployeeId); });
                        filteredAdvisorList = FinalAdvisorList.filter(function (item, index) { return item.UserId == (appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.AssignedEmployeeId); });
                        setServiceAdvisorList(filteredList);
                        saName = "";
                        if (filteredAdvisorList.length > 0) {
                            saName = filteredAdvisorList[0].GivenName + " " + filteredAdvisorList[0].FamilyName;
                        }
                        setFromAdvisor(saName);
                    }
                    else {
                        setServiceAdvisorList(FinalAdvisorList);
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error fetching vehicle types:", error_1);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onSaveClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload, _response$payload2, payload, url, _userData$data, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    payload = {};
                    url = void 0;
                    if (moduleName == EListCardView.JobCard) {
                        payload = {
                            AssignedEmployeeId: selectedAdvisor
                        };
                        url = ModifyAdvisorJobCardUrl(appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.JobCardId);
                    }
                    else if (moduleName == EListCardView.ServiceEstimate) {
                        payload = {
                            AssignedEmployeeId: selectedAdvisor
                        };
                        url = modifyEstimateUrl(appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.EstimateId);
                    }
                    else {
                        payload = {
                            AssignedEmployeeId: selectedAdvisor,
                            UserId: userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId
                        };
                        url = ModifyAdvisorUrl(appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.AppointmentId);
                    }
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: '',
                            url: url,
                            request: payload
                        }))];
                case 1:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) === 200)) return [3 /*break*/, 4];
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    onClosed(false);
                    dispatch(setState({
                        key: "menuValue",
                        value: data
                    }));
                    if (!(moduleName == EListCardView.JobCard)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: 'documentDetailsGetById',
                            url: jobCardGetDetailAPI(id)
                        }))];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    dispatch(showNotification({
                        isOpen: true,
                        message: data == EMenuFeature.AssignServiceAdvisor ? "Service advisor assigned successfully" : "Service advisor reassigned successfully",
                        type: "success"
                    }));
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("error", e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var getSubTitle = function () {
        if (moduleName == EListCardView.ServiceEstimate) {
            return t("EST No.- ") + "".concat((appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.SourceDocumentNo) || "");
        }
        else if (moduleName == EListCardView.JobCard) {
            return t("Job Card No.- ") + "".concat((appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.SourceDocumentNo) || "");
        }
        return t("Appointment No.- ") + "".concat((appointmentData === null || appointmentData === void 0 ? void 0 : appointmentData.SourceDocumentNo) || "");
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isOpen,
        title: data == EMenuFeature.AssignServiceAdvisor ? t('Assign service advisor') : t('Reassign service advisor'),
        subTitle: getSubTitle(),
        onClose: onClosed,
        variant: "h1",
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: '5px',
            color: 'secondary.500'
        },
        containerStyle: {
            padding: '0px 8px 0px 8px',
            width: lgMode ? '500px' : '100%'
        }
    }, /*#__PURE__*/ React.createElement(Loader, null), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            marginY: '10px'
        },
        direction: 'column',
        paddingBottom: "5px",
        width: '100%'
    }, data == EMenuFeature.AssignServiceAdvisor ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: "8px 10px 8px 5px",
        gap: '6px',
        sx: {
            ml: {
                xs: '3px',
                sm: '7px',
                md: '7px'
            }
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            ml: '2px'
        }
    }, t('Service advisor')), /*#__PURE__*/ React.createElement(MuiSelectComponent
    //displayConcat={true}
    , {
        caption: "Service Advisor",
        fullWidth: true,
        options: serviceAdvisorList || [],
        displayExpr: "advisorName",
        valueExpr: "UserId",
        name: "serviceadvisor",
        value: selectedAdvisor !== null && selectedAdvisor !== void 0 ? selectedAdvisor : '',
        onChange: function (event) {
            var _event$target$value, _event$target;
            setSelectedAdvisor((_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "");
        }
    })) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: "8px 15px 8px 5px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "medium",
        style: {
            marginLeft: '10px'
        }
    }, t('From SA')), /*#__PURE__*/ React.createElement(InputBox, {
        id: "serviceAdvisor",
        fullWidth: true,
        size: "small",
        value: fromAdvisor ? fromAdvisor : '-',
        name: "serviceadvisor",
        disabled: true,
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "secondary.50",
                borderRadius: '8px'
            }
        },
        style: {
            marginLeft: '6px',
            marginTop: '5px'
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "base",
        fontWeight: "medium",
        style: {
            marginLeft: '10px',
            marginTop: '10px'
        }
    }, t('To SA')), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        displayConcat: true,
        caption: "Service Advisor",
        fullWidth: true,
        options: serviceAdvisorList || [],
        displayExpr: "advisorName",
        valueExpr: "UserId",
        name: "serviceadvisor",
        value: selectedAdvisor !== null && selectedAdvisor !== void 0 ? selectedAdvisor : '',
        margin: '5px 10px 0px 6px',
        onChange: function (event) {
            var _event$target$value2, _event$target2;
            setSelectedAdvisor((_event$target$value2 = event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "");
        }
    })), /*#__PURE__*/ React.createElement(Button, {
        id: "saveButton",
        children: t('Save'),
        variant: "contained"
        // size='large'
        ,
        style: {
            // fontSize: "16px",
            // fontWeight: "500",
            marginTop: "10px",
            width: '95%',
            alignSelf: 'center'
            //opacity: !selectedAdvisor ? 0.5 : 1,
        },
        disabled: !selectedAdvisor,
        onClick: function () {
            onSaveClick();
            trackButtonClick("ButtonClickEvent", "Appointment" + "".concat(data == EMenuFeature.AssignServiceAdvisor ? t('Assign service advisor') : t('Reassign service advisor')) + "_Save_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(Button, {
        id: "cancelButton",
        children: t("Cancel"),
        style: {
            borderColor: "secondary.200",
            color: "secondary.600",
            fontSize: "16px",
            fontWeight: "500",
            marginTop: "16px",
            width: '95%',
            alignSelf: 'center'
        },
        onClick: function () {
            onClosed(false);
            trackButtonClick("ButtonClickEvent", "Appointment" + "".concat(data == EMenuFeature.AssignServiceAdvisor ? t('Assign service advisor') : t('Reassign service advisor')) + " Cancel Click", undefined);
        }
    })));
}
export default AppointmentAssignReassignPopup;
